import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import ErrorMessage from 'components/ErrorMessage'
import TextInput from 'components/TextInput'
import DatePicker from 'components/DatePicker'
import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

import { ValidThermostatModels } from 'types/Resource'

type Props = {
  version: string
  models: ValidThermostatModels[]
  releaseDate: string
  setVersion: (val: string) => void
  setModel: (val: ValidThermostatModels[]) => void
  setReleaseDate: (val: string) => void
  errors: {
    version?: string
    models?: string
    releaseDate?: string
  }
}

const thermostatModels = ['724', '824', '850', '1050', 'SC360', 'Pivot']

const ThermostatFields = ({ version, models, releaseDate, setVersion, setModel, setReleaseDate, errors }: Props) => {
  const handleChange = (event, model) => {
    if (event.target.checked) {
      setModel([...models, model])
    } else {
      setModel(models.filter((m) => m !== model))
    }
  }

  return (
    <>
      <TextInput
        isRequired
        label="Version"
        value={version}
        onChange={(event) => setVersion(event.target.value)}
        errorMessage={errors.version}
      />
      <span>Thermostat Model <strong>*</strong></span>
      <S.ModelWrapper>
        { thermostatModels.map((model: ValidThermostatModels) => (
          <Checkbox
            key={model}
            aria-label={model}
            label={model.toUpperCase()}
            checked={models.includes(model)}
            onChange={(e) => handleChange(e, model)}
          />
        ))
        }
      </S.ModelWrapper>
      {errors.models && <ErrorMessage errorMessage={errors.models} />}
      <span>Release Date <strong>*</strong></span>
      <S.DatePickerWrapper>
        <S.DatePicker
          label="Release Date *"
          value={releaseDate}
          onChangeCallback={(value) => setReleaseDate(moment(value).format('YYYY-MM-DD'))}
        />
        {errors.releaseDate && <ErrorMessage errorMessage={errors.releaseDate} />}
      </S.DatePickerWrapper>
    </>
  )
}

export default ThermostatFields

const S = {
  FormSection: styled(FormSection)`
    margin-bottom: 10px;
  `,
  ModelWrapper: styled.div`
    display: flex;
    margin-bottom: 15px;
    gap: 20px;
    flex-wrap: wrap;
  `,
  DatePickerWrapper: styled.div`
    display: block;
    margin-bottom: 15px;
    & > div{
      width: 100%;
      & > label{
        display: none;
      }
      & div > input {
        padding: 10.5px 14px;
      }
      & > div{
        border-radius: 0px !important;
     }
    }
  `,
  DatePicker: styled(DatePicker)`
    width: 100%;
  `
}
